<template>
    <div class="admin-pages">
        <PageTitle icon="fas fa-cogs iconInterativoTitulo" main="Administração do Sistema"
            sub="Gerenciamento e cadastro de novas baterias, equipamentos e colaboradores" />
        <div class="admin-pages-tabs">
            <b-card no-body>
                <b-tabs card>
                    <b-tab title="Baterias" active>
                        <BateriasAdmin />
                    </b-tab>
                    <b-tab title="Frota">
                        <MaquinasAdmin />
                    </b-tab>
                    <b-tab title="Usuarios">
                        <UsuariosAdmin />
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import BateriasAdmin from './BateriasAdmin'
import MaquinasAdmin from './MaquinasAdmin'
import UsuariosAdmin from './UsuariosAdmin'

export default {
    name: 'AdminPages',
    components: { PageTitle, BateriasAdmin, MaquinasAdmin, UsuariosAdmin }
}
</script>

<style>
.admin-pages {
    position: relative;
        width: 100%;
        height: 100%;
}
.iconInterativoTitulo {
    color: #008fac;
    font-size: 1.5em;
}
</style>
